import React, { useState, useEffect } from 'react';
import { Grid, Typography, TextField, Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

const WebmasterTools = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [googleCode, setGoogleCode] = useState('');
  const [bingCode, setBingCode] = useState('');
  const [baiduCode, setBaiduCode] = useState('');

  useEffect(() => {
    const w = settings.custom?.webmasterTools;
    if (!w) return;
    if (w.googleCode !== undefined) setGoogleCode(w.googleCode);
    if (w.bingCode !== undefined) setBingCode(w.bingCode);
    if (w.baiduCode !== undefined) setBaiduCode(w.baiduCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleSave = async () => {
    try {
      await updateSettings({
        custom: { webmasterTools: { googleCode, bingCode, baiduCode } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Google Search Console</Typography>
        <TextField
          fullWidth
          label="Enter your HTML code or ID"
          value={googleCode}
          onChange={(e) => setGoogleCode(e.target.value)}
        />
        <Button
          variant="outlined"
          size="small"
          sx={{ mt: 1 }}
          component="a"
          href="https://search.google.com/search-console"
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<OpenInNewIcon />}
        >
          Open Google Search Console
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Bing Webmaster Tools</Typography>
        <TextField
          fullWidth
          label="Enter your HTML code or ID"
          value={bingCode}
          onChange={(e) => setBingCode(e.target.value)}
        />
        <Button
          variant="outlined"
          size="small"
          sx={{ mt: 1 }}
          component="a"
          href="https://www.bing.com/webmasters"
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<OpenInNewIcon />}
        >
          Open Bing Webmaster Tools
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Baidu Webmaster Tool</Typography>
        <TextField
          fullWidth
          label="Enter your HTML code or ID"
          value={baiduCode}
          onChange={(e) => setBaiduCode(e.target.value)}
        />
        <Button
          variant="outlined"
          size="small"
          sx={{ mt: 1 }}
          component="a"
          href="https://ziyuan.baidu.com/site"
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<OpenInNewIcon />}
        >
          Open Baidu Webmaster Tools
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </Grid>

      <SaveSnackbar snack={snack} onClose={closeSnack} />
    </Grid>
  );
};

export default WebmasterTools;
